import { render } from '@testing-library/react';
import React, { Component, useEffect, useState, useLayoutEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
// import { GeoserverGetCapabilities } from '../../services/geoserver/GeoserverCapabilities';
import Meses from '../../services/Meses';
import NoticiasApi from '../../services/robinhood/NoticiasApi';
import FaqsCategoriasApi from '../../services/robinhood/FaqsCatergoriasApi';

export default function MenuFaq() {

  const meses = Meses;
  const [anos, setAnos] = useState([]);
  const [faqscategorias, setFaqscategorias] = useState([]);
  const location = useLocation();
  const [menu, setMenu] = useState(location.state ? location.state.faqcategoria.id : null);


  useEffect(() => {
    start();
  }, [])

  const start = async () => {
    await new FaqsCategoriasApi().all().then(response => {
      if (response) {
        response.sort((a, b) => {
          return a.categoria.localeCompare(b.categoria);
        });
        setFaqscategorias(response);
      }
    });
  }

  const handlerMenu = (categoria_id) => {
    if (menu != categoria_id)
      setMenu(categoria_id);
  }

  const CategoriaItem = (props) => {
    return (
      <>
        {faqscategorias.map(categoria => <li key={Math.random()} className={categoria.id === menu ? 'active open' : null}> <Link to={'/faqscategoria'} key={Math.random()} title={categoria.categoria} state={{ faqcategoria: { 'id': categoria.id, 'categoria': categoria.categoria, }, 'key': Math.random() }} onClick={() => handlerMenu(categoria.id)} className='waves-effect' style={{ fontWeight: '', fontSize: '13px' }}> <span> {categoria.categoria.toUpperCase()} </span> </Link></li>)}
      </>
    );
  }

  return (
    <>
      <div className="menu">
        <ul className="list">
          <li className="header"><strong> <i className='zmdi zmdi-calendar m-r-5'></i>  &nbsp;CATEGORIAS DISPONÍVEIS </strong></li>
          <li className={location.pathname == '/faqs' ? 'active open' : null}> <Link to={'/faqs'} className="waves-effect waves-classic" style={{ fontWeight: '', fontSize: '13px' }}> <span> TODAS OPÇÕES</span> </Link></li>
          <CategoriaItem />
        </ul>
      </div>
    </>
  );

}
